<template>
  <v-container class="content ma2">
    <div data-aos="fadeInUp">
      <div class="display-2 text--center">CONTACT US</div>
      <div class="grey--text subheading">Tell us about yourself</div>
    </div>

    <blockquote
      class="blockquote"
    >We are available and ready to service the GTA, Central Ontario and Golden Horseshoe area.</blockquote>
    <v-layout row wrap data-aos="fadeInUp">
      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">ADDRESS</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <div>Adjala Tosoronitio, Ontario</div>
            <div>
              <span>705.229.9403</span>
            </div>
            <span>
              <v-btn depressed small href="mailto:office@hydrovacking.ca">
                General
                <v-icon right>email</v-icon>
              </v-btn>&nbsp;&nbsp;
              <v-btn depressed small href="mailto:randy@hydrovacking.ca">
                Sales
                <v-icon right>email</v-icon>
              </v-btn>
            </span>
          </v-card-text>
        </v-card>

        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <div class="headline mb-0">CONTACT FORM</div>
              <div class="grey--text subheading">Tell us about yourself</div>
            </div>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field v-model="name" label="Name" :rules="requiredRules"></v-text-field>
              <v-text-field v-model="phone" label="Phone" :rules="requiredRules"></v-text-field>
              <v-text-field v-model="email" label="Email" :rules="emailRules"></v-text-field>
              <v-textarea v-model="message" label="Message"></v-textarea>

              <v-btn
                :loading="loading"
                :disabled="loading || !valid"
                color="secondary"
                @click="sendForm()"
              >
                Send
                <v-icon right>email</v-icon>
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-img src="../region.png"></v-img>

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">REGION</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>Regions serviced by HydrovacKing</span>
            <ul>
              <li>GTA</li>
              <li>Barrie</li>
              <li>Angus</li>
              <li>Innisfil</li>
              <li>Orillia</li>
              <li>Collingwood</li>
              <li>Newmarket</li>
              <li>Parry Sound</li>
              <li>NorthBay</li>
              <li>Sudbury</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snackbar" bottom>
      {{ emailResult }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import db from "@/firebase/init";

export default {
  data() {
    return {
      valid: true,
      requiredRules: [v => !!v || "Field is required"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      snackbar: false,
      loading: false,
      disabled: false,
      name: "",
      phone: "",
      email: "",
      message: "",
      emailResult: ""
    };
  },
  methods: {
    sendForm() {
      if (!this.$refs.form.validate()) {
        this.emailResult = "Validation Error";
        this.snackbar = true;
      } else {
        this.loading = true;

        db.collection("contacts")
          .add({
            name: this.name,
            phone: this.phone,
            email: this.email,
            message: this.message,
            date: new Date()
          })
          .then(() => {
            this.loading = false;
            this.name = "";
            this.phone = "";
            this.email = "";
            this.message = "";
            this.valid = true;
            this.emailResult = "Message Sent";
            this.snackbar = true;

            this.$refs.form.reset()
          })
          .catch(() => {
            this.loading = false;
            this.emailResult = "Error Sending Message";
            this.snackbar = true;
          });
      }
    }
  }
};
</script>

<style scoped>
</style>